import { render } from "./irrigationGroup.vue?vue&type=template&id=a9ee8768&scoped=true"
import script from "./irrigationGroup.vue?vue&type=script&lang=js"
export * from "./irrigationGroup.vue?vue&type=script&lang=js"

import "./irrigationGroup.vue?vue&type=style&index=0&id=a9ee8768&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9ee8768"]])

export default __exports__